// CompanyAdmin API configuration
// Keep CompanyAdmin aligned with the shared API config (defaults to port 5001 in local dev).
import {
  API_BASE_URL as SHARED_API_BASE_URL,
  getApiUrl as sharedGetApiUrl,
} from '../../config/api';

// Re-export with the same names CompanyAdmin code expects
export const API_BASE_URL = SHARED_API_BASE_URL;
export const getApiUrl = sharedGetApiUrl;

// Helper function to make API calls with credentials
export const apiCall = async (endpoint, options = {}) => {
  const url = getApiUrl(endpoint);
  
  const defaultOptions = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  return fetch(url, mergedOptions);
};
